import HOCWatchValue from 'components/common/hoc-watch-value';
import * as React from 'react';

import FlightItem from './items';

export default function FlightSaleItems() {
  const values = HOCWatchValue({ keys: ['approvalable.flightSales'] });

  return (
    <>
      {(values['approvalable.flightSales'] || []).map((item, idx) => (
        <FlightItem key={item.id} parentIndex={idx} />
      ))}
    </>
  );
}
